"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[487],{

/***/ 4285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "am": function() { return /* binding */ boxStyle; },
/* harmony export */   "js": function() { return /* binding */ BoxSection; },
/* harmony export */   "l": function() { return /* binding */ BoxDiv; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(964);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(45, 45, 48, 1);\n  border-radius: var(--border-radius);\n  padding: 0 var(--panel-padding);\n  margin: var(--panel-padding) 0;\n  box-shadow: var(--box-shadow);\n\n  article & > :first-child {\n    padding-top: var(--panel-padding);\n  }\n\n  article & > :last-child {\n    padding-bottom: var(--panel-padding);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(45, 45, 48, 1);\n  border-radius: var(--border-radius);\n  padding: 0 var(--panel-padding);\n  margin: var(--panel-padding) 0;\n  box-shadow: var(--box-shadow);\n\n  article & > :first-child {\n    padding-top: var(--panel-padding);\n  }\n\n  article & > :last-child {\n    padding-bottom: var(--panel-padding);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(45, 45, 48, 1);\n  border-radius: var(--border-radius);\n  padding: 0 var(--panel-padding);\n  margin: var(--panel-padding) 0;\n  box-shadow: var(--box-shadow);\n\n  article & > :first-child {\n    padding-top: var(--panel-padding);\n  }\n\n  article & > :last-child {\n    padding-bottom: var(--panel-padding);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var boxStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
var BoxDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9819e9f4-0"
})(_templateObject1());
var BoxSection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-9819e9f4-1"
})(_templateObject2());


/***/ }),

/***/ 7487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/layout/Footer.tsx

function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: "\xa9 Kewin Dousse 2014 - 2024"
    });
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(2692);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(964);
// EXTERNAL MODULE: ./src/translations.tsx + 2 modules
var translations = __webpack_require__(171);
// EXTERNAL MODULE: ./components/Box.tsx
var Box = __webpack_require__(4285);
;// CONCATENATED MODULE: ./components/layout/NavBar.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  justify-items: center;\n  margin: 0 !important;\n  padding: var(--navbar-padding);\n  position: relative;\n\n  & div {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: calc(-2 * var(--navbar-padding));\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Snav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-e9a6a41e-0"
})(_templateObject(), Box/* boxStyle */.am);
var AboutDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9a6a41e-1"
})(_templateObject1());
var LanguageDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9a6a41e-2"
})(_templateObject2());
function NavBar() {
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath, locale = router.locale;
    var t = (0,translations/* useT */.N)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Snav, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: t.navBar.home
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/categories",
                            children: t.navBar.categories
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AboutDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/about",
                                children: t.navBar.about
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LanguageDiv, {
                                children: [
                                    locale === "fr" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: asPath,
                                        locale: "en",
                                        children: "EN"
                                    }),
                                    locale === "en" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: asPath,
                                        locale: "fr",
                                        children: "FR"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "base",
                        children: "Protectator"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(6701);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(969);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(9384);
// EXTERNAL MODULE: ./components/layout/head/values.ts
var values = __webpack_require__(8266);
;// CONCATENATED MODULE: ./components/layout/head/HeadTags.tsx







function HeadTags(props) {
    var ref = (0,next_router.useRouter)(), locale = ref.locale, asPath = ref.asPath;
    var noNullProps = Object.fromEntries(Object.entries(props).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], v = _param[1];
        return v != null;
    }));
    var defaults = {
        title: values/* blogTitle */.MH,
        description: locale === "fr" ? values/* blogDescriptionFr */.Hz : values/* blogDescription */.tJ,
        noIndex: false
    };
    var ref1 = (0,_object_spread/* default */.Z)({}, defaults, noNullProps), title = ref1.title, description = ref1.description, noIndex = ref1.noIndex, image = ref1.image;
    var jsonLdWithContext = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org"
    }, props.jsonLd);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title !== defaults.title ? "".concat(title, " - ").concat(defaults.title) : title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: title,
                property: "og:title"
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: description,
                property: "og:description"
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: description,
                name: "description"
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "Keywords",
                lang: locale,
                content: values/* blogKeywords */.$G
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: values/* blogAuthorName */.yt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "Rev",
                content: values/* blogAuthorEmail */.zn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "copyright",
                content: "".concat(values/* blogCopyrightName */.qb, " ").concat(values/* blogCopyrightYears */.O1)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "profile",
                property: "og:type"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Kewin",
                property: "og:profile:first_name"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Dousse",
                property: "og:profile:last_name"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Protectator",
                property: "og:profile:username"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "male",
                property: "og:profile:gender"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "Protectator",
                property: "og:site_name"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#2f2f32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                type: "image/png",
                href: "/favicon.png"
            }),
            asPath && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: "en",
                        href: "".concat(utils/* ORIGIN */.jQ).concat(asPath)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: "fr",
                        href: "".concat(utils/* ORIGIN */.jQ, "/fr").concat(asPath)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(jsonLdWithContext)
                }
            }),
            noIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: "noindex,noarchive",
                name: "robots"
            }, "robots") : /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "all"
            }, "robots"),
            image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                content: image,
                property: "og:image"
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./components/layout/Layout.tsx





var Layout = function(param) {
    var title = param.title, description = param.description, noIndex = param.noIndex, image = param.image, children = param.children, jsonLd = param.jsonLd;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadTags, {
                title: title,
                description: description,
                noIndex: noIndex,
                image: image,
                jsonLd: jsonLd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "ga-script",
                strategy: "afterInteractive",
                dangerouslySetInnerHTML: {
                    __html: "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n          (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n\n          ga('create', 'UA-58143757-2', 'auto');\n          ga('set', 'anonymizeIp', true);\n          ga('send', 'pageview');"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 8266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ blogKeywords; },
/* harmony export */   "Hz": function() { return /* binding */ blogDescriptionFr; },
/* harmony export */   "MH": function() { return /* binding */ blogTitle; },
/* harmony export */   "O1": function() { return /* binding */ blogCopyrightYears; },
/* harmony export */   "qb": function() { return /* binding */ blogCopyrightName; },
/* harmony export */   "tJ": function() { return /* binding */ blogDescription; },
/* harmony export */   "yt": function() { return /* binding */ blogAuthorName; },
/* harmony export */   "zn": function() { return /* binding */ blogAuthorEmail; }
/* harmony export */ });
var blogDescription = "This blog is a place where I post my thoughts about various subjects mostly related to either programming or gaming stuff.";
var blogDescriptionFr = "Ce blog est un endroit o\xf9 je publie mes pens\xe9es sur divers sujets, principalement li\xe9s \xe0 la programmation et aux jeux vid\xe9o.";
var blogTitle = "Protectator";
var blogAuthorName = "Kewin Dousse";
var blogAuthorEmail = "me@protectator.ch";
var blogKeywords = "Protectator, blog, programming, gaming, code, Kewin, Dousse";
var blogCopyrightName = "Kewin Dousse";
var blogCopyrightYears = "2014-2024";


/***/ }),

/***/ 171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useT; }
});

// UNUSED EXPORTS: t

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./content/i18n/translations/en.tsx

var en = {
    navBar: {
        home: "Home",
        categories: "Categories",
        about: "About"
    },
    lang: {
        en: "EN",
        fr: "FR"
    },
    categories: {
        Gaming: "Gaming",
        Development: "Development",
        Ramblings: "Ramblings",
        Meta: "Meta"
    },
    generic: {
        minRead: "min read",
        comments: "Comments",
        categories: "Categories: ",
        category: "Category: ",
        noDisqus: "No Disqus in this environment.",
        unlisted1: "This post is unlisted: only those with this direct link can access it.",
        unlisted2: "Be careful who you share it with.",
        unavailableLanguage: "This post is only available in French."
    },
    pages: {
        home: {
            postsTitle: "Posts"
        },
        404: {
            title: "Error 404",
            subtitle: "Page not found",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The page you're looking for doesn't exist (anymore)."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "If you ended up here by following a link, don't hesitate to",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/Protectator",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "tell me"
                            }),
                            "!"
                        ]
                    })
                ]
            })
        },
        500: {
            title: "Error 500",
            subtitle: "Internal Server Error",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Oops, I messed up something and this page can't be displayed."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "If you ended up here by following a link, don't hesitate to",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/Protectator",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "tell me"
                            }),
                            "!"
                        ]
                    })
                ]
            })
        },
        about: {
            moreInfo1: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "If you're looking for more information, you might find it on my personal website at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.kewindousse.ch/",
                        children: "kewindousse.ch"
                    }),
                    "."
                ]
            }),
            moreInfo2: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "If you want to contact me, you should probably try to tweet",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://twitter.com/Protectator",
                        children: "@Protectator"
                    }),
                    "."
                ]
            })
        }
    }
};

;// CONCATENATED MODULE: ./content/i18n/translations/fr.tsx

var fr = {
    navBar: {
        home: "Accueil",
        categories: "Cat\xe9gories",
        about: "\xc0 propos"
    },
    lang: {
        en: "EN",
        fr: "FR"
    },
    categories: {
        Gaming: "Gaming",
        Development: "D\xe9veloppement",
        Ramblings: "Divagations",
        Meta: "Meta"
    },
    generic: {
        minRead: "minutes",
        comments: "Commentaires",
        categories: "Cat\xe9gories: ",
        category: "Cat\xe9gorie: ",
        noDisqus: "Pas de Disqus dans cet environnement.",
        unlisted1: "Cet article n'est pas r\xe9pertori\xe9: seuls ceux qui ont ce lien direct peuvent y acc\xe9der.",
        unlisted2: "Soyez attentif avec qui vous le partagez.",
        unavailableLanguage: "Cet article n'est disponible qu'en anglais."
    },
    pages: {
        home: {
            postsTitle: "Posts"
        },
        404: {
            title: "Erreur 404",
            subtitle: "Page not found",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "La page que vous recherchez n'existe pas (ou plus)."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Si vous \xeates arriv\xe9 ici en suivant un lien, n'h\xe9sitez pas \xe0",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/Protectator",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "me le dire"
                            }),
                            "!"
                        ]
                    })
                ]
            })
        },
        500: {
            title: "Erreur 500",
            subtitle: "Internal Server Error",
            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Oups, une erreur est survenue et cette page ne peut pas \xeatre affich\xe9e."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Si vous \xeates arriv\xe9 ici en suivant un lien, n'h\xe9sitez pas \xe0",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://twitter.com/Protectator",
                                target: "_blank",
                                rel: "noreferrer",
                                children: "me le dire"
                            }),
                            "!"
                        ]
                    })
                ]
            })
        },
        about: {
            moreInfo1: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Pour d'avantage d'informations, consultez mon site personnel \xe0 l'adresse ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.kewindousse.ch/",
                        children: "kewindousse.ch"
                    }),
                    " (en anglais)."
                ]
            }),
            moreInfo2: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Le moyen le plus simple de me contacter est sur twitter",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://twitter.com/Protectator",
                        children: "@Protectator"
                    }),
                    "."
                ]
            })
        }
    }
};

;// CONCATENATED MODULE: ./src/translations.tsx



var t = function(locale) {
    if (locale === "fr") {
        return fr;
    }
    return en;
};
var useT = function() {
    var locale = (0,router.useRouter)().locale;
    return t(locale);
};


/***/ }),

/***/ 9384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Po": function() { return /* binding */ displayDate; },
/* harmony export */   "Q4": function() { return /* binding */ getImageSrc; },
/* harmony export */   "ZS": function() { return /* binding */ getImageFullUrl; },
/* harmony export */   "jQ": function() { return /* binding */ ORIGIN; },
/* harmony export */   "mS": function() { return /* binding */ displayReadTime; },
/* harmony export */   "oA": function() { return /* binding */ isListable; },
/* harmony export */   "of": function() { return /* binding */ getSortedListablePosts; }
/* harmony export */ });
/* unused harmony exports bodyWordCount, isDraftDev, isDisplayable */
function displayDate(stringDate, locale) {
    return new Date(stringDate).toLocaleDateString(locale, {
        year: "numeric",
        month: "short",
        day: "numeric"
    });
}
function nodeWordCount(node) {
    if ("text" in node) {
        return node.text.split(" ").length;
    } else if ("children" in node) {
        return node.children.reduce(function(acc, child) {
            return acc + nodeWordCount(child);
        }, 0);
    }
    return 1;
}
// Counts the amount of words in the Tina body document
function bodyWordCount(body) {
    return nodeWordCount(body);
}
var WPM_READING_RATE = 225;
var ORIGIN = "https://protectator.ch";
function displayReadTime(post, t) {
    var words = bodyWordCount(post);
    var minutes = Math.floor(words / WPM_READING_RATE);
    return "".concat(minutes > 0 ? minutes : 1, " ").concat(t.generic.minRead);
}
function isDraftDev(post) {
    return post.status === "draft" && "production" === "development";
}
function isListable(post) {
    return post.status === "publish" || isDraftDev(post);
}
function isDisplayable(post) {
    return post.status === "publish" || post.status === "unlisted" || isDraftDev(post);
}
function getSortedListablePosts(nodes) {
    return nodes.filter(function(post) {
        return isListable(post);
    }).sort(function(a, b) {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    }).reverse();
}
var BASE_IMAGES_PATH = "/static/post_header";
function getImageSrc(fileName) {
    return {
        og: "".concat(BASE_IMAGES_PATH, "/out/").concat(fileName, "_og.jpg"),
        post: "".concat(BASE_IMAGES_PATH, "/out/").concat(fileName, "_post.jpg"),
        post_webp: "".concat(BASE_IMAGES_PATH, "/out/").concat(fileName, "_post.webp"),
        list: "".concat(BASE_IMAGES_PATH, "/out/").concat(fileName, "_list.jpg"),
        list_webp: "".concat(BASE_IMAGES_PATH, "/out/").concat(fileName, "_list.webp")
    };
}
function getImageFullUrl(fileSrc) {
    return "".concat(ORIGIN).concat(fileSrc);
}


/***/ })

}]);